import { render, staticRenderFns } from "./Sat.vue?vue&type=template&id=1b75de39&scoped=true&"
import script from "./Sat.vue?vue&type=script&lang=ts&"
export * from "./Sat.vue?vue&type=script&lang=ts&"
import style0 from "./Sat.vue?vue&type=style&index=0&id=1b75de39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b75de39",
  null
  
)

export default component.exports